// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_p2-0";
export var animationContainer = "_p2-1";
export var itemPrice = "_p2-a";
export var itemizedContent = "_p2-9";
export var itemizedHeader = "_p2-7";
export var itemizedRow = "_p2-8";
export var itemizedSection = "_p2-6";
export var modalContent = "_p2-2";
export var orderName = "_p2-3";
export var refundOption = "_p2-4";
export var refundOptionsContainer = "_p2-5";
export var shippingLabel = "_p2-b";
export var totalRow = "_p2-c";